import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3df0f50c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = { class: "line2" }
const _hoisted_5 = { class: "ls-form" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First name *", -1))
const _hoisted_8 = { class: "input-box" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last name *", -1))
const _hoisted_13 = { class: "input-box" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Position *", -1))
const _hoisted_18 = {
  class: "input-box",
  style: {"width":"50%"}
}
const _hoisted_19 = { class: "input-box" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Commenced Date *", -1))
const _hoisted_25 = { class: "input-box" }
const _hoisted_26 = { class: "date-picker" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Terminated Date", -1))
const _hoisted_30 = { class: "input-box" }
const _hoisted_31 = { class: "date-picker" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_35 = {
  class: "mt-4",
  style: {"text-align":"right"}
}
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "CANCEL ALERT", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Do you want to cancel this task?", -1))

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_v3_date_picker = _resolveComponent("v3-date-picker")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoadingData)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalBox, {
      show: _ctx.show,
      "onUpdate:show": _cache[12] || (_cache[12] = $event => ((_ctx.show) = $event)),
      onClose: _cache[13] || (_cache[13] = $event => (_ctx.cancelClicked()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.headerText), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.line2Text), 1)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("form", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("fieldset", null, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.directorRequest.firstName) = $event)),
                  disabled: _ctx.isLoadingData,
                  placeholder: "First name",
                  onInput: _cache[1] || (_cache[1] = $event => (_ctx.mandatoryCheck())),
                  maxLength: "50"
                }, null, 40, _hoisted_9), [
                  [_vModelText, _ctx.directorRequest.firstName]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["footnote", [ _ctx.directorRequest.firstName.length === 50 ? 'full' : '']])
                }, _toDisplayString(_ctx.directorRequest.firstName.length) + "/50 characters ", 3),
                (_ctx.directorRequest.firstName === '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _hoisted_11,
                      _createTextVNode(" Mandatory field ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("fieldset", null, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.directorRequest.lastName) = $event)),
                  disabled: _ctx.isLoadingData,
                  placeholder: "Last name",
                  onInput: _cache[3] || (_cache[3] = $event => (_ctx.mandatoryCheck())),
                  maxLength: "50"
                }, null, 40, _hoisted_14), [
                  [_vModelText, _ctx.directorRequest.lastName]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["footnote", [ _ctx.directorRequest.lastName.length === 50 ? 'full' : '']])
                }, _toDisplayString(_ctx.directorRequest.lastName.length) + "/50 characters ", 3),
                (_ctx.directorRequest.lastName === '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createTextVNode(" Mandatory field ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("fieldset", null, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.directorRequest.position) = $event)),
                  disabled: _ctx.isLoadingData,
                  placeholder: "Position",
                  onInput: _cache[5] || (_cache[5] = $event => (_ctx.mandatoryCheck())),
                  maxLength: "50"
                }, null, 40, _hoisted_20), [
                  [_vModelText, _ctx.directorRequest.position]
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["footnote", [ _ctx.directorRequest.position.length === 50 ? 'full' : '']])
                }, _toDisplayString(_ctx.directorRequest.position.length) + "/50 characters ", 3),
                (_ctx.directorRequest.position === '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _hoisted_22,
                      _createTextVNode(" Mandatory field ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_23,
          _createElementVNode("div", {
            class: "row",
            style: _normalizeStyle(_ctx.editMode ? 'width: 100%' : 'width: 50%')
          }, [
            _createElementVNode("fieldset", null, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_v3_date_picker, {
                    class: "v3-date-picker",
                    style: {"padding":"1em"},
                    onClick: _cache[6] || (_cache[6] = $event => (_ctx.mandatoryCheck())),
                    modelValue: _ctx.directorRequest.commencedDate,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.directorRequest.commencedDate) = $event)),
                    inputFormat: "dd-MM-yyyy"
                  }, null, 8, ["modelValue"]),
                  _hoisted_27
                ])
              ])
            ]),
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("fieldset", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_v3_date_picker, {
                        class: "v3-date-picker",
                        style: {"padding":"1em"},
                        onClick: _cache[8] || (_cache[8] = $event => (_ctx.mandatoryCheck())),
                        modelValue: _ctx.directorRequest.terminatedDate,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.directorRequest.terminatedDate) = $event)),
                        inputFormat: "dd-MM-yyyy",
                        lowerLimit: _ctx.from
                      }, null, 8, ["modelValue", "lowerLimit"]),
                      _hoisted_32
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 4),
          _hoisted_33
        ]),
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[10] || (_cache[10] = $event => (_ctx.cancelClicked())),
            disabled: _ctx.isLoadingData
          }, "Cancel", 8, _hoisted_36),
          _createElementVNode("button", {
            class: "btn btn-primary ml-2",
            disabled: !_ctx.canSubmit || _ctx.isLoadingData,
            onClick: _cache[11] || (_cache[11] = $event => (_ctx.submit()))
          }, [
            _createTextVNode(_toDisplayString(_ctx.submitBtnText) + " ", 1),
            _hoisted_38
          ], 8, _hoisted_37)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (_ctx.showCancelAlert)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 1,
          onClose: _cache[16] || (_cache[16] = $event => (_ctx.showCancelAlert = false))
        }, {
          header: _withCtx(() => [
            _hoisted_39
          ]),
          body: _withCtx(() => [
            _hoisted_40
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-secondary sml",
              onClick: _cache[14] || (_cache[14] = $event => (_ctx.yesClicked()))
            }, "Yes"),
            _createElementVNode("button", {
              class: "btn btn-tertiary sml",
              onClick: _cache[15] || (_cache[15] = $event => (_ctx.showCancelAlert = false))
            }, "No")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}